"use strict";
/**
 * Centralne definicje nagłówków kolumn dla arkuszy Excel
 *
 * UWAGA: Te nagłówki są wyświetlane użytkownikom końcowym w arkuszach Excel.
 * W przyszłości można dodać mechanizm tłumaczeń dla tych nagłówków.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEO_PRINT_LINE = exports.KEO_PRINT_HEADERS = exports.KPO_PRINT_LINE = exports.KPO_PRINT_HEADERS = exports.SHEET_EIGHT_HEADERS = exports.COMMON_REPORT_INFO = exports.WASTE_PROCESS_HEADERS = exports.WASTE_CODE_HEADERS = exports.KEO_ANNUAL_PERMIT_HEADERS = exports.KEO_ANNUAL_HEADERS = exports.KEO_MONTHLY_HEADERS = exports.KPO_CONFIRMED_HEADERS = exports.KPO_STATUS_HEADERS = void 0;
// KPO Status Overview
exports.KPO_STATUS_HEADERS = [
    "Nr KPO",
    "Kod odpadu",
    "Rodzaj odpadu",
    "Status",
    "Nr rej. pojazdu",
    "Osoba wystawiająca",
    "Data ostatniej modyfikacji",
    "Data odrzucenia",
    "Planowana data transportu",
    "Faktyczna data transportu",
];
// KPO Confirmed
exports.KPO_CONFIRMED_HEADERS = [
    "Nr KPO",
    "Kod odpadu",
    "Rodzaj odpadu",
    "Odpad niebezpieczny",
    "Masa odpadu [Mg]",
    "Status",
    "Data ostatniej modyfikacji",
    "Faktyczna data transportu",
    "Nr rej. pojazdu",
    "Nazwa transportującego",
    "Adres transportującego",
    "Data potwierdzenia przejęcia",
    "Nazwa przejmującego",
    "Miejsce prowadzenia działalności przejmującego",
    "Uwzględnione w Karcie Ewidencji Odpadów (KEO)",
    "Zdublowany wpis w KEO"
];
// KEO Monthly Statement
exports.KEO_MONTHLY_HEADERS = [
    "Kod odpadu",
    "Rodzaj odpadu",
    "Odpad niebezpieczny",
    //01
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //02
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //03
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //04
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //05
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //06
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //07
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //08
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //09
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //10
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //11
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    //12
    "Wytworzone w związku z eksploatacją instalacji [Mg]",
    "Wytworzone poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
];
// KEO Annual Report
exports.KEO_ANNUAL_HEADERS = [
    "Kod odpadu", //"wasteCode", 
    "Rodzaj odpadu", //"wasteCodeDescription", 
    "Numer karty KEO", //cardNumber
    "Masa wytworzonych odpadów w związku z eksploatacją instalacji [Mg]", //"wasteMassInstallation", 
    "Masa wytworzonych odpadów poza instalacją [Mg]", //"wasteMassExcludingInstallation", 
    "Łączna masa odpadów przetworzonych we własnym zakresie [Mg]", //"treatedWasteMass",
    "Łączna masa przekazanych odpadów [Mg]", // "forwardedWasteMass"
];
// KEO Annual Report with Permit
exports.KEO_ANNUAL_PERMIT_HEADERS = [
    "Kod odpadu",
    "Odpad niebezpieczny",
    "Rodzaj odpadu",
    "Masa wytworzonych odpadów w związku z eksploatacją instalacji [Mg]",
    "Masa wytworzonych odpadów poza instalacją [Mg]",
    "Łączna masa wytworzonych odpadów [Mg]",
    "Maksymalnie wg pozwolenia na wytwarzanie odpadów [Mg]",
    "Procent wartości z pozwolenia na wytwarzanie odpadów [%]",
];
// Waste Code Dictionary
exports.WASTE_CODE_HEADERS = [
    "Kod odpadu",
    "Nazwa odpadu",
    "Niebezpieczny",
    "Usunięty",
];
// Waste Process Dictionary  
exports.WASTE_PROCESS_HEADERS = [
    "Kod procesu",
    "Nazwa procesu odzysku lub unieszkodliwiania",
];
// Common report headers
exports.COMMON_REPORT_INFO = {
    REPORT_TITLE: "Raport wygenerowany przez",
    APP_NAME: "CARBOwaste Excel Add-in",
    GENERATED_DATE: "Data wygenerowania:",
    MPD_LABEL: "Miejsce prowadzenia działalności:",
    PERIOD_LABEL: "Okres:",
    NO_DATA_MESSAGE: "Brak danych do wyświetlenia dla wybranych kryteriów.",
    SUMMARY_TOTAL: "Łącznie:",
    SUMMARY_COUNT: "Liczba rekordów:",
};
exports.SHEET_EIGHT_HEADERS = {
    REPORT_TITLE: "RAPORT",
    DESCRIPTION: "OPIS",
    BDOENTITY: "PODMIOT BDO",
    MPD: "MIEJSCE PROWADZENIA DZIAŁALNOŚCI",
    MPD_NUMBER: "NUMER MPD",
    REPORT_PERIOD: "ZAKRES CZASOWY RAPORTU",
    REPORT_YEAR: "RAPORT ZA ROK",
    DATA_IMPORT: "DATA IMPORTU DANYCH"
};
exports.KPO_PRINT_HEADERS = {
    HEADER_0: "KARTA PRZEKAZANIA ODPADÓW",
    HEADER_1: "DANE PRZEKAZUJĄCEGO ODPADY",
    HEADER_2: "DANE TRANSPORTUJĄCEGO ODPADY",
    HEADER_3: "DANE PRZEJMUJĄCEGO ODPADY",
    HEADER_4: "INFORMACJE DOTYCZĄCE PRZEKAZYWANYCH ODPADÓW",
    HEADER_5: "INFORMACJE DOTYCZĄCE TRANSPORTU",
    HEADER_6: "INFORMACJE O PRZEJĘCIU ODPADÓW",
    HEADER_7: "INFORMACJE O KARCIE PRZEKAZANIA ODPADÓW",
    HEADER_7A: "Zatwierdzenie karty przekazania odpadów",
    HEADER_7B: "Potwierdzenie transportu odpadów",
    HEADER_7C: "Potwierdzenie przejęcia odpadów",
    HEADER_8: "INFORMACJE DODATKOWE",
};
exports.KPO_PRINT_LINE = {
    LINE_0_1: "Rok kalendarzowy",
    LINE_0_2: "Numer karty przekazania odpadów",
    LINE_0_3: "Status karty",
    LINE_1_1: "Numer rejestrowy przekazującego odpady",
    LINE_1_2: "NIP przekazującego odpady",
    LINE_1_3: "NIP europejski",
    LINE_1_4: "Nazwa lub imię i nazwisko przekazującego odpady",
    LINE_1_5: "Adres przekazującego odpady",
    LINE_1_6: "Numer miejsca prowadzenia działalności",
    LINE_1_7: "Nazwa miejsca prowadzenia działalności",
    LINE_1_8: "Adres miejsca prowadzenia działalności",
    LINE_1_9: "Wytwarzanie odpadów w wyniku świadczenia usług (w rozumieniu art. 3 ust. 1 pkt 32 ustawy o odpadach) i/lub działalności w zakresie obiektów liniowych (w rozumieniu art. 3 pkt 3a ustawy - Prawo budowlane)",
    LINE_1_10: "Miejsce wytwarzania odpadów",
    LINE_1_11: "Dodatkowe informacje o miejscu wytwarzania odpadów",
    LINE_2_1: "Numer rejestrowy",
    LINE_2_2: "NIP",
    LINE_2_3: "NIP europejski",
    LINE_2_4: "Nazwa lub imię i nazwisko",
    LINE_2_5: "Adres",
    LINE_3_1: "Numer rejestrowy przejmującego odpady",
    LINE_3_2: "NIP przejmującego odpady",
    LINE_3_3: "NIP europejski",
    LINE_3_4: "Nazwa lub imię i nazwisko przejmującego odpady",
    LINE_3_5: "Adres",
    LINE_3_6: "Numer miejsca prowadzenia działalności",
    LINE_3_7: "Nazwa miejsca prowadzenia działalności",
    LINE_3_8: "Adres miejsca prowadzenia działalności",
    LINE_4_1: "Rodzaj procesu przetwarzania",
    LINE_4_2: "Kod i rodzaj odpadów",
    LINE_4_3: "Kod ex",
    LINE_4_4: "Rodzaj odpadu ex",
    LINE_4_5: "Zmiana statusu odpadów niebezpiecznych na odpady inne niż niebezpieczne",
    LINE_4_6: "Rodzaj odpadu",
    LINE_4_7: "Masa odpadów [Mg]",
    LINE_4_8: "Numer certyfikatu oraz numery pojemników",
    LINE_4_9: "Skorygowana masa odpadów [Mg]",
    LINE_4_10: "Różnica masy odpadów [Mg]",
    LINE_5_1: "Numer rejestracyjny środka transportu / rodzaj środka transportu",
    LINE_5_2: "Data rozpoczęcia transportu",
    LINE_5_3: "Godzina rozpoczęcia transportu",
    LINE_5_4: "Faktyczna data rozpoczęcia transportu",
    LINE_5_5: "Faktyczna godzina rozpoczęcia transportu",
    LINE_6_1: "Masa odpadów przyjętych [Mg]",
    LINE_6_2: "Data potwierdzenia przejęcia odpadów",
    LINE_6_3: "Godzina potwierdzenia przejęcia odpadów",
    LINE_6_4: "Uwagi",
    LINE_7A_1: "Imię i nazwisko osoby zatwierdzającej kartę",
    LINE_7A_2: "Data zatwierdzenia karty",
    LINE_7A_3: "Godzina zatwierdzenia karty",
    LINE_7B_1: "Imię i nazwisko osoby potwierdzającej transport",
    LINE_7B_2: "Data potwierdzenia transportu",
    LINE_7B_3: "Godzina potwierdzenia transportu",
    LINE_7C_1: "Imię i nazwisko osoby potwierdzającej przejęcie",
    LINE_7C_2: "Data potwierdzenia przejęcia",
    LINE_7C_3: "Godzina potwierdzenia przejęcia",
    LINE_8_1: "Dodatkowe informacje",
};
exports.KEO_PRINT_HEADERS = {
    HEADER_0: "KARTY EWIDENCJI ODPADU",
    HEADER_1: "DANE POSIADACZA ODPADÓW",
    HEADER_2: "MIEJSCE PROWADZENIA DZIAŁALNOŚCI",
    HEADER_3: "DZIAŁALNOŚĆ W ZAKRESIE WYTWARZANIA ODPADÓW",
    HEADER_4: "GOSPODARKA ODPADAMI",
};
exports.KEO_PRINT_LINE = {
    LINE_0_1: "Rok kalendarzowy",
    LINE_0_2: "Numer karty ewidencji odpadów",
    LINE_0_3: "Kod i rodzaj odpadu",
    LINE_0_4: "Kod ex",
    LINE_0_5: "Rodzaj odpadu ex",
    LINE_0_6: "Zmiana statusu odpadów niebezpiecznych na odpady inne niż niebezpieczne",
    LINE_0_7: "Rodzaj odpadu",
    LINE_1_1: "Numer rejestrowy",
    LINE_1_2: "NIP",
    LINE_1_3: "NIP europejski",
    LINE_1_4: "Nazwa lub imię i nazwisko",
    LINE_1_5: "Adres",
    LINE_2_1: "Numer miejsca prowadzenia działalności",
    LINE_2_2: "Nazwa miejsca prowadzenia działalności",
    LINE_2_3: "Adres miejsca prowadzenia działalności",
    LINE_3_1: "Wytwarzanie",
    LINE_3_2: "Zbieranie",
    LINE_3_3: "Odzysk",
    LINE_3_4: "Unieszkodliwianie",
    TABLE_0: "Data",
    TABLE_1: "Masa wytworzonych odpadów [Mg]",
    TABLE_1_1: "W związku z eksploatacją instalacji",
    TABLE_1_2: "Poza instalacją",
    TABLE_2: "Masa wytworzonych odpadów w wyniku świadczenia usług i/lub działalności w zakresie obiektów liniowych [Mg]",
    TABLE_2_1: "W związku z eksploatacją instalacji",
    TABLE_2_2: "Poza instalacją",
    TABLE_3: "Masa odpadów wydobytych ze składowiska [Mg]",
    TABLE_4: "Odpady przyjęte przez posiadacza odpadów",
    TABLE_4_1: "Masa [Mg]",
    TABLE_4_2: "Numer KPO",
    TABLE_5: "Przetwarzanie odpadów",
    TABLE_5_1: "Masa [Mg]",
    TABLE_5_2: "R/D",
    TABLE_5_3: "Zawartość PCB w odpadzie [%]",
    TABLE_5_4: "Sposób gospodarowania",
    TABLE_6: "Masa przekazanych odpadów",
    TABLE_6_1: "w kraju [Mg]",
    TABLE_6_2: "Numer KPO",
    TABLE_6_3: "za granicę [Mg]",
    TABLE_7: "Imię i nazwisko osoby sporządzającej",
    TABLE_8: "Informacje dodatkowe",
    TABLE_10: "Podsumowanie:",
};
//# sourceMappingURL=headers.js.map